import React, { Component } from 'react'
import './css.css';

class Dev extends Component {
   
    render(){
        console.log(this.props.update) 
        return ( 
            <div>
                <div id="bows_flyer" className="text white">
                    <div id="bows_mainlabel">💀 JOIN OPEN DEVELOPMENT</div>
                    <div id="bows_sublabel">All Opportunities for Remote Devs</div>
                    <div className="bows_panel dark darkblue text white">
                        <div className="instructions_title light lightblue text white">🌷 OFFER</div>
                        <br></br><br></br>
                        We are the SmartShop Community and you are a lonely Dev.
                        <br></br>
                        <br></br>
                        Now you are not alone anymore.
                        <br></br>
                        <br></br>
                        A SmartShop is a modular vending machine, you add a new module and you completely change the functionality of the machne and the possibilities.
                        <br></br>
                        <br></br>
                        You build a selling module of some sort.
                        <br></br>
                        <br></br>
                        We accept it by vote.
                        <br></br>
                        <br></br>
                        You become a god in the community because you add tools = power = value
                        <br></br>
                        <br></br>
                        We ideally run that module forever in the platform<br></br>
                        <br></br>
                        <br></br>
                        You ideally get 20% of the money produces by the fees, forever.
                        <br></br>
                        <br></br>
                        20% will go to referrals
                        <br></br>
                        <br></br>
                        60% to SmartShop vault for platform_development/hackathons/income (if the ideation of the module is by third party so 1% go to module ideator)
                        <br></br>
                        <br></br><br></br>
                        <div className="instructions_title light lightblue text white">🔫 RULES</div>
                        <br></br><br></br>
                        Join Discord server
                        <br></br>
                        <br></br>
                        Choose a module you want to build (from the ideas list or by inventing a new idea)
                        <br></br>
                        <br></br>
                        Book it, by publicly declaring your interest
                        <br></br>
                        <br></br>
                        The community will review your proposal and give you suggestions
                        <br></br>
                        <br></br>
                        If no complaint is raised your booking is valid
                        <br></br>
                        <br></br>
                        You have 3 months to build the module
                        <br></br>
                        <br></br>
                        Module is then installed in the platform by collective vote
                        <br></br>
                        <br></br>
                    </div>
                </div>
            </div>
        );
    }

}

export default Dev